import { checkboxAnatomy } from '@chakra-ui/anatomy'
import { defineSlotRecipe } from '@chakra-ui/react'

export const checkboxSlotRecipe = defineSlotRecipe({
  slots: checkboxAnatomy.keys,
  className: 'chakra-checkbox',
  base: {
    control: {
      cursor: 'pointer',
      borderRadius: 'sm',
    },
    label: {
      fontWeight: '400',
      userSelect: 'none',
      _disabled: {
        opacity: '0.5',
      },
    },
  },
  variants: {
    variant: {
      solid: {
        control: {
          borderColor: 'brand.blue',
          '&:is([data-state=checked], [data-state=indeterminate])': {
            bg: 'brand.blue',
            color: 'colorPalette.contrast',
            borderColor: 'colorPalette.solid',
          },
        },
      },
    },
  },
})
